import { ApplicationController, useTransition, useIntersection } from 'stimulus-use';

export default class extends ApplicationController {
  static values = {
    delay: Number,
  };

  connect() {
    this.initialized = false;
    window.addEventListener('turbo:morph', () => {
      this.initialized = false;
      this.enable();
    });
    this.enable();
  }

  enable() {
    // Skip animation on small screens (< 768px)
    if (window.innerWidth < 768) {
      this.element.classList.remove('opacity-0', 'translate-y-6');
      this.element.classList.add('opacity-100', 'translate-y-0');
      this.element.style.opacity = '1';
      this.element.style.transform = 'translateY(0)';
      this.initialized = true;
      return;
    }

    // Only initialize animation once for medium+ screens
    if (this.initialized) {
      return;
    }

    // Reset inline styles to let CSS classes work
    this.element.style.opacity = '';
    this.element.style.transform = '';

    useIntersection(this, {
      threshold: 0.3,
    });
    useTransition(this, {
      hiddenClass: 'opacity-0',
      transitioned: false,
      preserveOriginalClass: false,
    });
    this.initialized = true;
  }

  appear(entry) {
    if (entry.isIntersecting) {
      this.open();
    }
  }

  open() {
    if (this.delayValue) {
      setTimeout(() => {
        this.enter();
      }, this.delayValue * 1000);
    } else {
      this.enter();
    }
  }
}
